import { useUser } from '~/modules/main'

export const getMappedPrice = (price) => {
  // const { $gaApp } = useNuxtApp()
  const { userIsAuth } = useUser()

  // $gaApp.features.get('guestPrices')
  const isGuestPrices = false

  let prefix = false

  if (!userIsAuth.value) {
    prefix = isGuestPrices ? price.viewOptions.priceFrom : price.hasLoyalty
  }

  return {
    old: price.old || undefined,
    actual: price.actual,
    oldStrikethrough: price.viewOptions.crossPrice,
    prefix,
  }
}
